// Dictionary assembly. Fragments are split by area so screens can be edited in
// parallel; build() throws on a duplicate key so two fragments can never claim
// the same one (same guard as PMO).
import { common } from './dicts/common';
import { shell } from './dicts/shell';
import { repertoire } from './dicts/repertoire';
import { fiche } from './dicts/fiche';
import { gouvernance } from './dicts/gouvernance';
import { tickets } from './dicts/tickets';
import { mywork } from './dicts/mywork';
import { observation } from './dicts/observation';
import { admin } from './dicts/admin';
import { github } from './dicts/github';
import { control } from './dicts/control';
import { landscape } from './dicts/landscape';

export type Lang = 'fr' | 'en';
export type Dict = Record<string, string>;
export interface Fragment { fr: Dict; en: Dict }

export const LANGUAGES: { code: Lang; label: string }[] = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
];

const FRAGMENTS: Fragment[] = [common, shell, repertoire, fiche, gouvernance, tickets, mywork, observation, admin, github, landscape, control];

function build(lang: Lang): Dict {
  const out: Dict = {};
  for (const fragment of FRAGMENTS) {
    for (const [key, value] of Object.entries(fragment[lang])) {
      if (key in out) throw new Error(`i18n: duplicate key "${key}"`);
      out[key] = value;
    }
  }
  return out;
}

const fr = build('fr');
const en = build('en');
// EN falls back to the FR string (French is the working language), then the key.
export const dictionaries: Record<Lang, Dict> = { fr, en: { ...fr, ...en } };
